import { Container, Title, Text, Stack } from '@/components/ui';
import { useAiWorkflowStore } from '../../../../stores/aiWorkflowStore';
import SelectPreset from './SelectPreset';
import UploadInput from './UploadInput';
import ProcessingStatus from './ProcessingStatus';
import ReviewExtractedData from './ReviewExtractedData';
import ConfirmAndCreate from './ConfirmAndCreate';
import WorkflowComplete from './WorkflowComplete';

export default function WorkflowWizardPage() {
  const { currentStep } = useAiWorkflowStore();

  const renderStep = () => {
    switch (currentStep) {
      case 'select-preset': return <SelectPreset />;
      case 'upload': return <UploadInput />;
      case 'processing': return <ProcessingStatus />;
      case 'review': return <ReviewExtractedData />;
      case 'confirm': return <ConfirmAndCreate />;
      case 'complete': return <WorkflowComplete />;
      default: return <SelectPreset />;
    }
  };

  return (
    <Container fluid py="xl">
      <Stack gap="lg">
        <div>
          <Title order={2}>AI Workflow</Title>
          <Text c="dimmed">Create records from images, audio, or text using AI.</Text>
        </div>
        {renderStep()}
      </Stack>
    </Container>
  );
}
